/**
 * Función para obtener la variación DRC sólidos
 * @param {*} data - Datos de ingreso con la finca
 * @returns { aplica: boolean, variacion: number } - Objeto con la variación DRC sólidos y si aplica o no
 */
export const getVariacionDRCSolidosFromFinca = (data) => {
    let variacionDRC = { aplica: false, variacion: 0 };

    let finca = {};
    if (data && data.ingreso && data.ingreso.finca) {
        finca = data.ingreso.finca;
    }

    if (!finca || !finca.aplica_variacion_drc) {
        return variacionDRC;
    }

    const historial_variacion_drc = finca && finca.historial_variacion_drc;

    if (historial_variacion_drc && historial_variacion_drc.length > 0) {
        const variacionDRCSolidos = historial_variacion_drc[historial_variacion_drc.length - 1].variacion_drc_solidos;
        variacionDRC = { aplica: true, variacion: variacionDRCSolidos };
    }

    return variacionDRC;
}

/**
 * Función para calcular el DRC sólidos
 * @param {*} registroDRC - Registro de DRC sólidos
 * @returns {drc_promedio_1, drc_promedio_2, drc_promedio_3} - Objeto con los DRC promedio
 */
export const calcularDRCSolidos = (registroDRC) => {
    const { peso_crepa, peso_muestra,
        peso_seco_1, peso_humedo_1,
        peso_seco_2, peso_humedo_2,
        peso_seco_3, peso_humedo_3 } = registroDRC;

    let drc_promedio_1 = 0;
    let drc_promedio_2 = 0;
    let drc_promedio_3 = 0;

    if (!peso_crepa || !peso_muestra) {
        return { drc_promedio_1, drc_promedio_2, drc_promedio_3 };
    }

    if (peso_crepa && peso_muestra) {
        if (peso_seco_1 && peso_humedo_1) {
            drc_promedio_1 = (((peso_seco_1 / peso_humedo_1) * peso_crepa) / peso_muestra)
        }

        if (peso_seco_2 && peso_humedo_2) {
            drc_promedio_2 = (((peso_seco_2 / peso_humedo_2) * peso_crepa) / peso_muestra)
        }

        if (peso_seco_3 && peso_humedo_3) {
            drc_promedio_3 = (((peso_seco_3 / peso_humedo_3) * peso_crepa) / peso_muestra)
        }

        return { drc_promedio_1, drc_promedio_2, drc_promedio_3 };
    }
}

/**
 * Función para calcular el DRC sólidos original
 * @param {*} registroDRC - Registro de DRC sólidos
 * @returns {drc1_original, drc2_original, drc3_original} - Objeto con los DRC original
 */
export const calcularDRCSolidosOriginal = (registroDRC) => {
    const { peso_crepa, peso_muestra,
        peso_seco_1_original, peso_humedo_1,
        peso_seco_2_original, peso_humedo_2,
        peso_seco_3_original, peso_humedo_3 } = registroDRC;

    let drc1_original = 0;
    let drc2_original = 0;
    let drc3_original = 0;

    if (!peso_crepa || !peso_muestra) {
        return { drc1_original, drc2_original, drc3_original };
    }

    if (peso_crepa && peso_muestra) {
        if (peso_seco_1_original && peso_humedo_1) {
            drc1_original = (((peso_seco_1_original / peso_humedo_1) * peso_crepa) / peso_muestra)
        }

        if (peso_seco_2_original && peso_humedo_2) {
            drc2_original = (((peso_seco_2_original / peso_humedo_2) * peso_crepa) / peso_muestra)
        }

        if (peso_seco_3_original && peso_humedo_3) {
            drc3_original = (((peso_seco_3_original / peso_humedo_3) * peso_crepa) / peso_muestra)
        }

        return { drc1_original, drc2_original, drc3_original };
    }
}
